module.exports = __webpack_public_path__ + "media/images/emblems/Wileroltigen-coat_of_arms-4c227857c9361cfa8349c19fc5f36345.svg";